import React from 'react';

import Domains from '@lcsc-ui/utils/domains';
import { Image } from 'antd';

const InfoPageRight = ({ infoList }) => {
  return (
    <section className="float-right w-[27%]">
      <div className="hangye_right">
        {infoList?.informationAd?.url ? (
          <a href={infoList.informationAd.url}>
            <Image alt="广告图片" preview={false} src={infoList.informationAd.imgSrc} width="100%" />
          </a>
        ) : (
          <Image
            alt="广告图片"
            preview={false}
            className="rounded-[10px]"
            src="//static.szlcsc.com/ecp/assets/web/page/activity/informationIndustryDetails/images/infolistguanggou.jpg"
            width="100%"
          />
        )}
      </div>
      <div className="hangye_right pb-[2px] pt-[1px] bg-white mt-[16px] rounded-[10px]">
        <div className="hyzx_rmzx w-[99%] mb-[4px]">
          <div className="hyzx_rmzx_title h-[43px] m-[4px_5%_0] leading-[44px] flex items-center">
            <div className="h-[15px] w-[3px] bg-[#0094e7] mr-[8px]"></div>
            <div className="h-[43px] w-[30%] text-[16px] font-bold text-[#0094e7] float-left leading-[43px]">
              热门物料
            </div>
          </div>
          <div id="rotate" className="hyzx_rmzx_txt w-[310px] relative m-[0_auto]">
            <div className="hyzx_c w-full bg-[#e6ebf5] text-center m-[0_auto] overflow-hidden">
              <div className="w-[60%] text-left float-left pl-[15px] leading-[24px] text-[14px]">型号</div>
              <div className="w-[35%] float-left leading-[24px] text-[14px]">价格</div>
            </div>
            <table className="hyzx_table w-[90%] text-[12px] text-center m-[0_auto] overflow-hidden border-collapse">
              <tbody data-spm="wl">
                {infoList?.hotProductList?.map((item, index) => (
                  <tr key={index} className="hyzx_tr border-solid border-[#f0f0f0] border-b last:border-none">
                    <td className="cursor-pointer text-left w-[132px] text-[#666] leading-[18px] overflow-hidden h-[48px] align-middle">
                      <a
                        data-spm={index + 1}
                        href={`${Domains.lcscItemUrl}/${item.productId}.html`}
                        className="break-all text-[#666] hover:text-[#0094e7]"
                        target="_blank"
                      >
                        {item.productModel}/{item.productType}
                      </a>
                    </td>
                    <td className="text-[#666] leading-[24px] overflow-hidden h-[48px]"></td>
                    <td className="w-[80px] text-[#f96] leading-[24px] overflow-hidden h-[48px] align-middle">
                      {item.productLadderPrice}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="hangye_right pb-[2px] pt-[1px] bg-white mt-[16px] rounded-[10px]">
        <div className="hyzx_rmzx w-[99%] mb-[4px]">
          <div className="hyzx_rmzx_title h-[43px] m-[4px_5%_0] leading-[44px] flex items-center">
            <div className="h-[15px] w-[3px] bg-[#0094e7] mr-[8px]"></div>
            <div className="h-[43px] w-[30%] text-[16px] font-bold text-[#0094e7] float-left leading-[43px]">
              热门资讯
            </div>
          </div>
          <div className="m-[0_5%]">
            <ul className="m-[4px_auto]" data-spm="zx">
              {(infoList?.techArticleList || infoList?.hotIndustryMessageList)?.map((techArticle, index) => (
                <li key={index} className="leading-[28px] reactive indent-[10px]  ">
                  <div className="absolute mt-[10px] w-0 h-0 border-[4px] border-solid border-t-transparent border-b-transparent border-l-[#999] border-r-transparent"></div>
                  <a
                    data-spm={index + 1}
                    className="text-gray-600 block whitespace-nowrap overflow-hidden text-ellipsis font-size-[14px]"
                    href={`${Domains.lcscWwwUrl}/info/${techArticle.informationId}.html`}
                    title={techArticle.title}
                  >
                    {techArticle.title.slice(0, 50)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
export default InfoPageRight;
